export default "__VITE_ASSET__BhmmavP3__"